import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/core/api.service';
import { UserService } from 'src/app/core/user.service';
import { ErrCode, User } from 'src/app/shared/models';
import { environment } from '../../../../environments/environment'
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { ShareService } from 'src/app/shared/services/share.service';

@Component({
  selector: 'app-dialog-display-avatar',
  templateUrl: './dialog-display-avatar.component.html',
  styleUrls: ['./dialog-display-avatar.component.scss']
})
export class DialogDisplayAvatarComponent implements OnInit {

  @Input() showAvatarDialog: boolean;
  @Input() user: User;
  @Output() showAvatarDialogChange = new EventEmitter<boolean>();
  @ViewChild('dialogDisplayAvatar') dialogDisplayAvatar!: ElementRef<HTMLInputElement>;
  public avatarEndpoint: string;
  public avatarForm: FormGroup;
  //avatar attributes
  public logo: string; //either default image path or base64 image
  private defaultLogo: string;
  public showAlert: boolean = false;
  public errcode: ErrCode;
  @Output() avatarUrlUpdated: EventEmitter<void> = new EventEmitter<void>()

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private httpClient: HttpClient,
    private api: ApiService,
    private snackbarService: SnackbarService,
    private shareService: ShareService,
  ) { }

  ngOnInit(): void {
    this.defaultLogo = this.user.avatar.avatar_data;
    this.avatarEndpoint = `${environment.logohost}avatar/saved/`;

    if (!this.defaultLogo) {
      this.defaultLogo = '';
    }
    //set things to saved settings or default
    this.logo = this.defaultLogo;
    this.createForm();
  }

  openDialog = () => {
    this.dialogDisplayAvatar.nativeElement.click();
  }

  private createForm() {
    this.avatarForm = this.fb.group({
      logo: [null],
    });
  }

  async uploadFile(filelist: any) {
    const files = filelist.target.files;
    if (!files || files.length == 0) {
      return;
    }
    const logoFile = files.item(0);
    const path = '/upload/whitelabel';
    const formData: FormData = new FormData();
    formData.append('file', logoFile, logoFile.name);
    console.log(environment.imageconversionhost)
    //api call for image preprocessing
    this.httpClient
      .post(environment.imageconversionhost + path, formData)
      .subscribe({
        next: (response) => {
          if (response['success']) {
            this.logo = response['imgdata'];
            this.showAlert = false;
          }
        },
        error: (err) => {
          if (err) {
            this.showAlert = true;
            this.errcode = new ErrCode(
              err.error.error_code,
              'The file format is unsupported. Please try again'
          );
          }
        }
      });
  }

  clearAvatar = async () => {
    this.showAlert = false;
    this.logo = '';
  }

  saveProfileChanges = async () => {
    //api call to store the image
    try {
      if (!this.avatarForm.valid) { return; }
      await this.api.execute('uploadavatar', { imgBase64: this.logo });
      this.closeAvatarDialog();
      this.snackbarService.showMessage("success", "Profile picture updated.");
      this.userService.refresh();
      // Get current timestamp
      const timeStamp = new Date().getTime();

      // Update avatarUrl in the shared service
      this.shareService.updateAvatarUrlWithTimestamp(timeStamp, this.logo === '' ? true : false);
    } catch (ex) {
      this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
    }
  }

  closeAvatarDialog = () => {
    this.showAvatarDialog = false;
    setTimeout(() => { 
      this.showAvatarDialogChange.next(false);
    });
  }

}
